module.exports = __webpack_public_path__ + "static/img/14.81d4458.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/8/1/zh/14.png
// module id = CQkT
// module chunks = 0